module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div id="social_photo_empty" class="gphotos_empty empty_albums">\n    ' +
((__t = ( I18n.t('uploader.social.empty_albums') )) == null ? '' : __t) +
'\n</div>\n<div id="gphotos_albums_wrapper">\n    <div id="social_photo_loading"></div>\n    <div id="gphotos_albums_container"></div>\n    <div id="load_more" tabindex="0">' +
((__t = ( I18n.t('uploader.social.load_more') )) == null ? '' : __t) +
'</div>\n</div>\n<div id="back_albums" class="bottom_button" role="button" tabindex="0">' +
((__t = ( I18n.t('uploader.social.back') )) == null ? '' : __t) +
'</div>\n';

}
return __p
}